import { render, staticRenderFns } from "./TabProjects.vue?vue&type=template&id=ca747e30&scoped=true"
import script from "./TabProjects.vue?vue&type=script&lang=ts"
export * from "./TabProjects.vue?vue&type=script&lang=ts"
import style0 from "./TabProjects.vue?vue&type=style&index=0&id=ca747e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca747e30",
  null
  
)

export default component.exports